(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-list-ring')) {
    class CollectionListRing extends HTMLElement {
      constructor() {
        super();
	        this.onClick = this.onClick.bind(this);
	        this.onPointerDown = this.onPointerDown.bind(this);
	        this.onPointerMove = this.onPointerMove.bind(this);
	        this.onPointerUp = this.onPointerUp.bind(this);
	        this.onWheel = this.onWheel.bind(this);
	        this.onViewportChange = this.onViewportChange.bind(this);
	        this.animationEnd = null;
	        this.animationTimer = null;
	        this.drag = null;
	        this.isAnimating = false;
	        this.suppressClick = false;
	        this.lastWheelAbs = 0;
	        this.lastWheelDirection = 0;
	        this.lastWheelEventAt = 0;
	        this.lastWheelMoveAt = 0;
	        this.wheelAccum = 0;
	        this.wheelCooldown = false;
	        this.wheelCooldownTimer = null;
	        this.wheelTimer = null;
	      }

      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.track = this.querySelector('[data-mobile-ring-slider]');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentElement = this.querySelector('[data-mobile-ring-current]');

        if (!this.track) return;

        this.slides = this.getSlides();
        this.currentIndex = this.getInitialIndex();

	        this.addEventListener('click', this.onClick);
	        this.track.addEventListener('pointerdown', this.onPointerDown);
	        this.track.addEventListener('wheel', this.onWheel, { passive: false });

        if (typeof this.mediaQuery.addEventListener === 'function') {
          this.mediaQuery.addEventListener('change', this.onViewportChange);
        } else {
          this.mediaQuery.addListener(this.onViewportChange);
        }

        requestAnimationFrame(() => this.updateUI());
      }

      disconnectedCallback() {
	        this.removeEventListener('click', this.onClick);
	        this.track?.removeEventListener('pointerdown', this.onPointerDown);
	        this.track?.removeEventListener('wheel', this.onWheel);
	        this.cancelDrag();
	        window.clearTimeout(this.animationTimer);
	        window.clearTimeout(this.wheelCooldownTimer);
	        window.clearTimeout(this.wheelTimer);

        if (typeof this.mediaQuery?.removeEventListener === 'function') {
          this.mediaQuery.removeEventListener('change', this.onViewportChange);
        } else {
          this.mediaQuery?.removeListener(this.onViewportChange);
        }
      }

      get isMobile() {
        return this.mediaQuery?.matches;
      }

	      getSlides() {
	        return Array.from(this.querySelectorAll('[data-mobile-ring-slide]'));
	      }

	      getClones() {
	        return Array.from(this.querySelectorAll('[data-mobile-ring-clone]'));
	      }

      getInitialIndex() {
        const active = this.querySelector('[data-mobile-ring-slide].is-active');
        const initial = this.querySelector('[data-mobile-ring-initial]');
        const slide = active || initial || this.slides[0];

        return this.getSlideIndex(slide);
      }

      getSlideIndex(slide) {
        return Number(slide?.dataset.mobileRingIndex || 1);
      }

      getSlideByIndex(index) {
        return this.slides.find((slide) => this.getSlideIndex(slide) === index);
      }

	      wrap(index) {
	        const total = this.slides.length;

	        return total ? ((index - 1 + total) % total) + 1 : 1;
	      }

	      removeClones() {
	        this.getClones().forEach((clone) => clone.remove());
	        this.classList.remove('is-ring-ready');
	      }

	      createClone(sourceSlide, className) {
	        if (!sourceSlide) return null;

	        const clone = sourceSlide.cloneNode(true);
	        clone.classList.remove('is-before-active', 'is-active', 'is-after-active');
	        clone.classList.add(className);
	        clone.removeAttribute('id');
	        clone.removeAttribute('style');
	        clone.removeAttribute('data-mobile-ring-slide');
	        clone.removeAttribute('data-mobile-ring-index');
	        clone.removeAttribute('data-mobile-ring-initial');
	        clone.removeAttribute('data-cascade');
	        clone.setAttribute('data-mobile-ring-clone', '');
	        clone.setAttribute('aria-hidden', 'true');

	        if ('inert' in clone) {
	          clone.inert = true;
	        }

	        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
	        [clone, ...clone.querySelectorAll('*')].forEach((element) => {
	          Array.from(element.attributes).forEach((attribute) => {
	            if (attribute.name.startsWith('data-shopify-')) {
	              element.removeAttribute(attribute.name);
	            }
	          });
	        });
	        clone.querySelectorAll('a, button, input, textarea, select, [tabindex]').forEach((element) => {
	          element.setAttribute('tabindex', '-1');

	          if (element.tagName === 'A') {
	            element.removeAttribute('href');
	          }
	        });

	        return clone;
	      }

	      updateClones(beforeSource, afterSource) {
	        this.getClones().forEach((clone) => clone.remove());

	        const beforeClone = this.createClone(beforeSource, 'is-clone-before');
	        const afterClone = this.createClone(afterSource, 'is-clone-after');

	        if (beforeClone) {
	          this.track.insertBefore(beforeClone, this.track.firstElementChild);
	        }

	        if (afterClone) {
	          this.track.appendChild(afterClone);
	        }

	        this.classList.add('is-ring-ready');
	      }

	      updateUI() {
	        this.slides = this.getSlides();

	        if (this.slides.length < 1) return;

	        if (!this.isMobile) {
	          this.removeClones();
	          return;
	        }

	        const activeSlide = this.getSlideByIndex(this.currentIndex) || this.slides[0];
	        this.currentIndex = this.getSlideIndex(activeSlide);

	        const beforeSlide = this.getSlideByIndex(this.wrap(this.currentIndex - 1));
	        const afterSlide = this.getSlideByIndex(this.wrap(this.currentIndex + 1));
	        const cloneBeforeSlide = this.getSlideByIndex(this.wrap(this.currentIndex - 2));
	        const cloneAfterSlide = this.getSlideByIndex(this.wrap(this.currentIndex + 2));

        this.slides.forEach((slide) => {
          slide.classList.remove('is-before-active', 'is-active', 'is-after-active');
        });

	        beforeSlide?.classList.add('is-before-active');
	        activeSlide.classList.add('is-active');
	        afterSlide?.classList.add('is-after-active');
	        this.updateClones(cloneBeforeSlide, cloneAfterSlide);

        if (this.currentElement) {
          this.currentElement.textContent = this.currentIndex;
        }

        this.prevButton?.removeAttribute('disabled');
        this.nextButton?.removeAttribute('disabled');
      }

      move(direction) {
        if (!this.isMobile || this.isAnimating || this.slides.length < 2) return;

        const targetIndex = this.wrap(this.currentIndex + direction);

        if (this.motionQuery.matches) {
          this.currentIndex = targetIndex;
          this.updateUI();
          return;
        }

        this.isAnimating = true;
        this.targetIndex = targetIndex;
        this.classList.add(direction > 0 ? 'is-animating-next' : 'is-animating-prev');

        this.animationEnd = (event) => {
          if (event && event.target !== this.track) return;
          this.finishMove();
        };

        this.track.addEventListener('transitionend', this.animationEnd);
        this.animationTimer = window.setTimeout(() => this.finishMove(), 310);
      }

      finishMove() {
        if (!this.isAnimating) return;

        this.track.removeEventListener('transitionend', this.animationEnd);
        window.clearTimeout(this.animationTimer);

        this.currentIndex = this.targetIndex;
        this.classList.add('is-resetting');
        this.classList.remove('is-animating-prev', 'is-animating-next', 'is-dragging');
        this.track.style.removeProperty('--collection-list-ring-drag-offset');
        this.updateUI();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.classList.remove('is-resetting');
            this.isAnimating = false;
          });
        });
      }

	      onClick(event) {
	        if (this.suppressClick && event.target.closest('a')) {
	          event.preventDefault();
	          event.stopPropagation();
	          this.suppressClick = false;
	          return;
	        }

	        const previous = event.target.closest('button[name="previous"]');
	        const next = event.target.closest('button[name="next"]');

        if (!this.isMobile || (!previous && !next) || !this.contains(event.target)) return;

	        event.preventDefault();
	        this.move(next ? 1 : -1);
	      }

	      lockWheelBriefly(delay = 120) {
	        this.wheelCooldown = true;
	        window.clearTimeout(this.wheelCooldownTimer);
	        this.wheelCooldownTimer = window.setTimeout(() => {
	          if (this.isAnimating) {
	            this.lockWheelBriefly(60);
	            return;
	          }

	          this.wheelAccum = 0;
	          this.wheelCooldown = false;
	        }, delay);
	      }

	      onWheel(event) {
	        if (!this.isMobile || this.slides.length < 2) return;

	        const now = window.performance.now();
	        const absX = Math.abs(event.deltaX);
	        const absY = Math.abs(event.deltaY);

	        if (absX <= absY) return;

	        event.preventDefault();

	        const direction = event.deltaX > 0 ? 1 : -1;
	        const isContinuousGesture = now - this.lastWheelEventAt < 120;
	        const isSameDirection = direction === this.lastWheelDirection;
	        const isDecayingInertia = isContinuousGesture && isSameDirection && absX <= this.lastWheelAbs * 1.35;

	        this.lastWheelAbs = absX;
	        this.lastWheelDirection = direction;
	        this.lastWheelEventAt = now;

	        if (this.isAnimating || isDecayingInertia) {
	          this.wheelAccum = 0;
	          window.clearTimeout(this.wheelTimer);
	          return;
	        }

	        if (this.wheelCooldown) {
	          this.wheelCooldown = false;
	          window.clearTimeout(this.wheelCooldownTimer);
	        }

	        this.wheelAccum += event.deltaX;
	        window.clearTimeout(this.wheelTimer);

	        if (Math.abs(this.wheelAccum) >= 20) {
	          const targetDirection = this.wheelAccum > 0 ? 1 : -1;

	          this.wheelAccum = 0;
	          this.lastWheelMoveAt = now;
	          this.lockWheelBriefly(120);
	          this.move(targetDirection);
	          return;
	        }

	        this.wheelTimer = window.setTimeout(() => {
	          this.wheelAccum = 0;
	        }, 150);
	      }

	      onPointerDown(event) {
	        if (!this.isMobile || this.isAnimating) return;
	        if (event.pointerType === 'mouse' && event.button !== 0) return;
	        if (event.target.closest('button, input, textarea, select')) return;

	        this.suppressClick = false;
	        this.drag = {
	          startX: event.clientX,
	          startY: event.clientY,
          locked: null
        };

        this.track.addEventListener('pointermove', this.onPointerMove);
        this.track.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.drag) return;

        const dx = event.clientX - this.drag.startX;
        const dy = event.clientY - this.drag.startY;

        if (this.drag.locked === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          this.drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';

          if (this.drag.locked === 'y') {
            this.cancelDrag();
            return;
          }

          try {
            this.track.setPointerCapture(event.pointerId);
          } catch (error) {}
        }

	        event.preventDefault();
	        this.classList.add('is-dragging');
	        this.suppressClick = true;
	        this.track.style.setProperty('--collection-list-ring-drag-offset', `${dx}px`);
	      }

      onPointerUp(event) {
        if (!this.drag) return;

        const dx = event.clientX - this.drag.startX;
        const slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
        const threshold = Math.max(36, Math.min(80, slideWidth * 0.18));
        const shouldMove = this.drag.locked === 'x' && Math.abs(dx) >= threshold;
        const direction = dx < 0 ? 1 : -1;

	        if (shouldMove) {
	          this.cancelDrag(false);
	          this.classList.remove('is-dragging');
	          this.track.style.removeProperty('--collection-list-ring-drag-offset');
	          this.move(direction);
	        } else {
	          this.cancelDrag();
	        }

	        if (this.suppressClick) {
	          window.setTimeout(() => {
	            this.suppressClick = false;
	          }, 350);
	        }
	      }

      cancelDrag(resetOffset = true) {
        if (!this.drag) return;

        this.track.removeEventListener('pointermove', this.onPointerMove);
        this.track.removeEventListener('pointerup', this.onPointerUp);
        this.track.removeEventListener('pointercancel', this.onPointerUp);
        this.drag = null;

	        if (resetOffset) {
	          this.classList.remove('is-dragging');
	          this.track.style.removeProperty('--collection-list-ring-drag-offset');
	        }
	      }

	      onViewportChange() {
	        window.clearTimeout(this.animationTimer);
	        window.clearTimeout(this.wheelCooldownTimer);
	        this.isAnimating = false;
	        this.wheelAccum = 0;
	        this.wheelCooldown = false;
	        this.classList.add('is-resetting');
	        this.track?.style.removeProperty('--collection-list-ring-drag-offset');
	        this.classList.remove('is-animating-prev', 'is-animating-next', 'is-dragging');
        this.updateUI();

        requestAnimationFrame(() => {
          this.classList.remove('is-resetting');
        });
      }
    }

    customElements.define('collection-list-ring', CollectionListRing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs-section')) {
    class CollectionTabsSection extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.resizeFrame = null;
        this.drag = null;
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onResize);

        // Parse IWT sync map : "id_tab0,id_tab1,id_tab2,id_tab3" → ["id_tab0", "id_tab1", ...]
        this.iwtSyncIds = (this.dataset.iwtSync || '').split(',').map(s => s.trim());

        // Onglet actif initial = celui rendu par Liquid selon la collection courante
        this.initialActiveIndex = parseInt(this.dataset.activeIndex, 10) || 0;

        requestAnimationFrame(() => {
          this.initActiveSlider();
          this.handleHashOnLoad();
          // Sync IWT au load (onglet actif de la collection courante si pas de hash)
          if (!window.location.hash.match(/^#tab-\d+$/)) {
            this.syncIwtSections(this.initialActiveIndex);
          }
        });
      }

      syncIwtSections(activeIndex) {
        if (!this.iwtSyncIds || !this.iwtSyncIds.length) return;
        this.iwtSyncIds.forEach((sectionId, idx) => {
          if (!sectionId) return;
          const el = document.getElementById('shopify-section-' + sectionId);
          if (!el) return;
          el.classList.toggle('iwt-tab-active', idx === activeIndex);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('resize', this.onResize);

        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      }

      handleHashOnLoad() {
        const match = window.location.hash.match(/^#tab-(\d+)$/);
        if (!match) return;
        const tabIndex = Number(match[1]);
        const tab = this.querySelector(`[role="tab"][data-tab-index="${tabIndex}"]`);
        if (!tab) return;
        this.activateTab(String(tabIndex), false);
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = this.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top, behavior: 'smooth' });
        this.syncIwtSections(tabIndex);
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      get panels() {
        return Array.from(this.querySelectorAll('[role="tabpanel"]'));
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) {
          this.activateTab(tab.dataset.tabIndex, true);
          return;
        }

        const prevButton = event.target.closest('[data-pct-prev]');
        if (prevButton && this.contains(prevButton)) {
          this.move(prevButton.closest('[role="tabpanel"]'), -1);
          return;
        }

        const nextButton = event.target.closest('[data-pct-next]');
        if (nextButton && this.contains(nextButton)) {
          this.move(nextButton.closest('[role="tabpanel"]'), 1);
          return;
        }

        const dot = event.target.closest('[data-dot-index]');
        if (dot && this.contains(dot)) {
          this.goTo(dot.closest('[role="tabpanel"]'), Number(dot.dataset.dotIndex));
        }
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        const tabs = this.tabs;
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        this.activateTab(tabs[nextIndex].dataset.tabIndex, true);
      }

      activateTab(index, focusTab) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tabIndex === String(index);
          tab.classList.toggle('ct-tabs__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && focusTab) tab.focus();
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panelIndex === String(index);
          panel.classList.toggle('ct-tabs__panel--active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });

        this.syncIwtSections(Number(index));

        requestAnimationFrame(() => this.initActiveSlider());
      }

      initActiveSlider() {
        const panel = this.querySelector('[role="tabpanel"]:not([hidden])');
        if (!panel) return;
        const state = this.getState(panel);
        if (!state) return;
        this.refresh(state);
      }

      getState(panel) {
        if (panel._ctSlider) return panel._ctSlider;

        const container = panel.querySelector('[data-pct-slider]');
        const track = panel.querySelector('[data-pct-track]');
        if (!container || !track) return null;

        const slides = Array.from(track.querySelectorAll('.pct-slider__slide'));
        if (!slides.length) return null;

        const state = {
          panel,
          container,
          track,
          slides,
          dots: Array.from(panel.querySelectorAll('[data-dot-index]')),
          total: slides.length,
          maxIndex: 0,
          currentIndex: 0,
          step: 0,
          offset: 0,
          wheelAccum: 0,
          wheelTimer: null,
          wheelCooldown: false
        };

        container.addEventListener('pointerdown', (e) => this.onPointerDown(e, state));
        container.addEventListener('wheel', (e) => this.onWheel(e, state), { passive: false });

        panel._ctSlider = state;
        return state;
      }

      refresh(state) {
        const firstSlide = state.slides[0];
        const slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : 0;
        const styles = window.getComputedStyle(state.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;

        state.step = slideWidth + gap;
        const visible = Math.max(1, Math.round((state.container.clientWidth + gap) / state.step));
        state.maxIndex = Math.max(0, state.total - visible);

        const isStatic = state.maxIndex === 0;
        state.panel.classList.toggle('ct-tabs__panel--static', isStatic);

        if (state.currentIndex > state.maxIndex) state.currentIndex = state.maxIndex;
        this.applyTransform(state, false);
        this.updateUI(state);
      }

      applyTransform(state, dragging) {
        const x = -(state.currentIndex * state.step) + state.offset;
        state.track.style.transform = `translate3d(${x}px, 0, 0)`;
        state.track.classList.toggle('pct-slider__track--dragging', !!dragging);
      }

      updateUI(state) {
        state.dots.forEach((dot, index) => {
          const isActive = index === state.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.toggleAttribute('aria-current', isActive);
        });

        const prev = state.panel.querySelector('[data-pct-prev]');
        const next = state.panel.querySelector('[data-pct-next]');
        if (prev) prev.toggleAttribute('disabled', state.currentIndex <= 0);
        if (next) next.toggleAttribute('disabled', state.currentIndex >= state.maxIndex);
      }

      move(panel, direction) {
        if (!panel) return;
        const state = this.getState(panel);
        if (!state || state.maxIndex === 0) return;
        this.goTo(panel, state.currentIndex + direction);
      }

      goTo(panel, target) {
        if (!panel) return;
        const state = this.getState(panel);
        if (!state || state.maxIndex === 0 || Number.isNaN(target)) return;

        state.currentIndex = Math.max(0, Math.min(state.maxIndex, target));
        state.offset = 0;
        this.applyTransform(state, false);
        this.updateUI(state);
      }

      onWheel(event, state) {
        if (state.maxIndex === 0) return;

        const absX = Math.abs(event.deltaX);
        const absY = Math.abs(event.deltaY);
        if (absX <= absY) return;

        event.preventDefault();

        if (state.wheelCooldown) return;

        state.wheelAccum += event.deltaX;
        clearTimeout(state.wheelTimer);

        const threshold = 30;
        if (Math.abs(state.wheelAccum) >= threshold) {
          const direction = state.wheelAccum > 0 ? 1 : -1;
          state.wheelAccum = 0;
          state.wheelCooldown = true;

          const next = state.currentIndex + direction;
          if (next >= 0 && next <= state.maxIndex) {
            state.currentIndex = next;
            this.applyTransform(state, false);
            this.updateUI(state);
          }

          setTimeout(() => { state.wheelCooldown = false; }, 500);
          return;
        }

        state.wheelTimer = setTimeout(() => { state.wheelAccum = 0; }, 150);
      }

      onPointerDown(event, state) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (state.maxIndex === 0) return;
        if (event.target.closest('a, button')) return;

        this.drag = {
          state,
          startX: event.clientX,
          startY: event.clientY,
          locked: null
        };

        state.container.addEventListener('pointermove', this.onPointerMove);
        state.container.addEventListener('pointerup', this.onPointerUp);
        state.container.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.drag) return;
        const dx = event.clientX - this.drag.startX;
        const dy = event.clientY - this.drag.startY;

        if (this.drag.locked === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          this.drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (this.drag.locked === 'y') {
            this.cancelDrag();
            return;
          }
          try { this.drag.state.container.setPointerCapture(event.pointerId); } catch (e) {}
        }

        if (this.drag.locked === 'x') {
          event.preventDefault();
          this.drag.state.offset = dx;
          this.applyTransform(this.drag.state, true);
        }
      }

      onPointerUp(event) {
        if (!this.drag) return;
        const state = this.drag.state;
        const dx = event.clientX - this.drag.startX;

        if (this.drag.locked === 'x' && state.step > 0) {
          const threshold = state.step * 0.2;
          if (dx <= -threshold && state.currentIndex < state.maxIndex) {
            state.currentIndex += 1;
          } else if (dx >= threshold && state.currentIndex > 0) {
            state.currentIndex -= 1;
          }
        }

        state.offset = 0;
        this.applyTransform(state, false);
        this.updateUI(state);
        this.cancelDrag();
      }

      cancelDrag() {
        if (!this.drag) return;
        const container = this.drag.state.container;
        container.removeEventListener('pointermove', this.onPointerMove);
        container.removeEventListener('pointerup', this.onPointerUp);
        container.removeEventListener('pointercancel', this.onPointerUp);
        this.drag = null;
      }

      onResize() {
        if (this.resizeFrame) return;
        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.panels.forEach((panel) => {
            if (!panel.hidden && panel._ctSlider) this.refresh(panel._ctSlider);
          });
        });
      }
    }

    customElements.define('collection-tabs-section', CollectionTabsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var tab = event.target.closest('.flavor-menu__tab');
    if (!tab) return;

    var menu = tab.closest('.flavor-menu');
    if (!menu) return;

    var target = tab.dataset.tab;
    if (!target) return;

    menu.querySelectorAll('.flavor-menu__tab').forEach(function(button) {
      var isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
      var isActive = panel.dataset.tabPanel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-carousel')) {
    class TestimonialsCarousel extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.frame = null;
        this.resizeFrame = null;
        this.isRefreshing = false;
        this.canLoop = false;
        this.currentIndex = 0;
        this.slideStep = 0;
        this.setWidth = 0;
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-testimonials-slider]');
        this.track = this.querySelector('[data-testimonials-track]');
        if (!this.slider || !this.track) return;

        this.originalSlides = Array.from(this.track.querySelectorAll('[data-testimonials-slide]:not([data-testimonials-clone])'));
        this.dots = Array.from(this.querySelectorAll('[data-testimonials-dot]'));
        this.total = this.originalSlides.length;

        this.originalSlides.forEach((slide, index) => {
          slide.dataset.testimonialsIndex = String(index);
        });

        this.addEventListener('click', this.onClick);
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        requestAnimationFrame(() => this.refresh(false));
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('resize', this.onResize);

        if (this.slider) {
          this.slider.removeEventListener('scroll', this.onScroll);
        }

        if (this.frame) {
          cancelAnimationFrame(this.frame);
        }

        if (this.resizeFrame) {
          cancelAnimationFrame(this.resizeFrame);
        }
      }

      onClick(event) {
        const previous = event.target.closest('[data-testimonials-prev]');
        if (previous && this.contains(previous)) {
          this.scrollBySlides(-1);
          return;
        }

        const next = event.target.closest('[data-testimonials-next]');
        if (next && this.contains(next)) {
          this.scrollBySlides(1);
          return;
        }

        const dot = event.target.closest('[data-testimonials-dot]');
        if (dot && this.contains(dot)) {
          this.goToSlide(Number(dot.dataset.testimonialsDotIndex));
        }
      }

      onScroll() {
        if (this.isRefreshing || !this.canLoop || !this.slideStep || !this.setWidth || this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.normalizeLoopPosition();
          this.updateDots();
        });
      }

      onResize() {
        if (this.resizeFrame) return;

        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.refresh(true);
        });
      }

      refresh(preserveIndex) {
        const currentIndex = preserveIndex && this.canLoop ? this.getRealIndex() : this.currentIndex;

        this.isRefreshing = true;
        this.removeClones();
        this.measure();

        this.setWidth = this.slideStep * this.total;
        this.canLoop = this.total > 1 && this.setWidth > this.slider.clientWidth + 1;
        this.classList.toggle('testimonials-carousel--static', !this.canLoop);

        if (this.canLoop && this.slideStep > 0) {
          this.currentIndex = this.mod(currentIndex, this.total);
          this.addClones();
          this.slider.scrollLeft = this.setWidth + this.currentIndex * this.slideStep;
        } else {
          this.currentIndex = 0;
          this.slider.scrollLeft = 0;
        }

        this.updateDots();

        requestAnimationFrame(() => {
          this.isRefreshing = false;
        });
      }

      measure() {
        const firstSlide = this.originalSlides[0];
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;

        this.slideStep = firstSlide ? firstSlide.getBoundingClientRect().width + gap : 0;
      }

      addClones() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        this.originalSlides.forEach((slide) => {
          before.appendChild(this.createClone(slide));
          after.appendChild(this.createClone(slide));
        });

        this.track.insertBefore(before, this.originalSlides[0]);
        this.track.appendChild(after);
      }

      createClone(slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.testimonialsClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-nosnippet', '');
        clone.setAttribute('inert', '');

        clone.querySelectorAll('[id]').forEach((element) => {
          element.removeAttribute('id');
        });

        clone.querySelectorAll('a, button, input, select, textarea, summary, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });

        [clone, ...clone.querySelectorAll('*')].forEach((element) => {
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) {
              element.removeAttribute(attribute.name);
            }
          });
        });

        return clone;
      }

      removeClones() {
        this.track.querySelectorAll('[data-testimonials-clone]').forEach((clone) => clone.remove());

        this.originalSlides
          .slice()
          .sort((a, b) => Number(a.dataset.testimonialsIndex) - Number(b.dataset.testimonialsIndex))
          .forEach((slide) => this.track.appendChild(slide));
      }

      normalizeLoopPosition() {
        const scrollLeft = this.slider.scrollLeft;

        if (scrollLeft >= this.setWidth * 2) {
          this.slider.scrollLeft = scrollLeft - this.setWidth;
        } else if (scrollLeft < this.setWidth * 0.1) {
          this.slider.scrollLeft = scrollLeft + this.setWidth;
        }
      }

      scrollBySlides(direction) {
        if (!this.canLoop || !this.slideStep) return;

        this.slider.scrollBy({
          left: direction * this.slideStep,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      goToSlide(targetIndex) {
        if (!this.canLoop || Number.isNaN(targetIndex)) return;

        const diff = this.shortestDiff(this.getRealIndex(), targetIndex, this.total);
        if (!diff) return;

        this.slider.scrollBy({
          left: diff * this.slideStep,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      updateDots() {
        this.currentIndex = this.canLoop ? this.getRealIndex() : this.currentIndex;

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);

          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      getRealIndex() {
        if (!this.total || !this.slideStep) return 0;

        const offset = this.canLoop && this.setWidth
          ? this.mod(this.slider.scrollLeft, this.setWidth)
          : this.slider.scrollLeft;

        return this.mod(Math.round(offset / this.slideStep), this.total);
      }

      shortestDiff(from, to, total) {
        let diff = to - from;

        if (diff > total / 2) {
          diff -= total;
        } else if (diff < total / -2) {
          diff += total;
        }

        return diff;
      }

      mod(value, total) {
        return ((value % total) + total) % total;
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }

    customElements.define('testimonials-carousel', TestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
